/**
 * Reglas de audiencia alineadas al modelo de notificaciones del portal.
 */

export function notificationAppliesToTenant(notification, tenantId) {
  if (!tenantId) return false;
  const raw = notification?.tenant;
  if (raw == null || String(raw).trim() === "") return true;
  const tenantIds = String(raw)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  return tenantIds.includes(tenantId);
}

export function getUserCustomsFlags() {
  if (typeof window === "undefined") {
    return { userHasCBP: true, userHasCBSA: true };
  }
  const v = (localStorage.getItem("customsBorder") || "CBP").toUpperCase();
  return {
    userHasCBP: v === "CBP",
    userHasCBSA: v === "CBSA",
  };
}

/** Si la notificación está ligada a una sola aduana, solo la ven usuarios de esa aduana. */
export function notificationMatchesUserCustoms(notification, flags) {
  const { userHasCBP, userHasCBSA } = flags;
  const cbp = !!notification?.isActiveCBP;
  const cbsa = !!notification?.isActiveCBSA;
  if (!cbp && !cbsa) return true;
  if (cbp && cbsa) return true;
  if (cbp) return userHasCBP;
  if (cbsa) return userHasCBSA;
  return true;
}

export function isNotificationPastExpiration(notification) {
  if (!notification?.expirationDate) return true;
  return new Date(notification.expirationDate).getTime() < Date.now();
}

/**
 * Vigente a efectos de negocio: no vencida por fecha y, si es Portal, isActive.
 * Informative u otros tipos: vigente si no pasó expirationDate.
 */
export function isNotificationCurrentlyActive(notification) {
  return !isNotificationPastExpiration(notification) || notification?.isActive === true;
}

export function filterNotificationsForViewer(notifications, tenantId, customsFlags) {
  return (notifications || []).filter(
    (n) =>
      notificationAppliesToTenant(n, tenantId) &&
      notificationMatchesUserCustoms(n, customsFlags)
  );
}

export function getNotificationReadStorageKey(userId, tenantId) {
  return `openedPortalNotifications:${userId || "unknown"}:${tenantId || "unknown"}`;
}

export function getOpenedNotificationIds(userId, tenantId) {
  if (typeof window === "undefined") return [];
  try {
    const key = getNotificationReadStorageKey(userId, tenantId);
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function markNotificationOpened(notificationId, userId, tenantId) {
  if (typeof window === "undefined" || !notificationId) return;
  try {
    const key = getNotificationReadStorageKey(userId, tenantId);
    const current = getOpenedNotificationIds(userId, tenantId);
    if (current.includes(notificationId)) return;
    window.localStorage.setItem(key, JSON.stringify([...current, notificationId]));
  } catch (error) {
    // no-op: reading state is a non-critical UX enhancement
  }
}

export function countUnreadActiveNotifications(
  notifications,
  tenantId,
  customsFlags,
  openedIds
) {
  const opened = new Set(openedIds || []);
  const forViewer = filterNotificationsForViewer(notifications, tenantId, customsFlags);
  return forViewer.filter((notification) => {
    const isActive = isNotificationCurrentlyActive(notification);
    const isNew = notification?.isNew !== false;
    const isOpened = opened.has(notification?.id);
    return isActive && isNew && !isOpened;
  }).length;
}
